/* eslint-disable security/detect-object-injection */
export default {
  namespaced: true,
  state: {},
  mutations: {
    updateRouteProp (state, {property, value}) {
      state[property] = value;
    }
  },
  actions: {},
  getters: {}
};
